export default __webpack_public_path__ + "static/media/img_4.cb5dc5a3.JPG";